
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import {
  orderDetail,
  createOrderAgain,
  refundListDetail,
  orderReceived,
  pageVisit,
  orderCancel,
  getDataOrder
} from '@/services/http';
import orderRequestAnchorSrc from '@/tools/orderRequestAnchorSrc';
import { dateTimeFormatter, readCookie, writeStorage } from '@/tools/tools';
import CountDown from '@/components/countdown/index.vue';
import BackTop from '@/common/backtop.vue';
import * as _ from 'lodash';

function totalDiscountFilter(d: any) {
  if (!d || d.totalFee === undefined) {
    return '0.00';
  }
  const fee = Number(d.totalFee) || 0;
  const log = Number(d.logisticsFee) || 0;
  const amt = Number(d.totalAmount) || 0;
  const raw = fee + log - amt;
  const v = Math.round(raw * 100) / 100;
  if (v < 0) {
    return '0.00';
  }
  return v.toFixed(2);
}

@Component({
  name: 'OrderDetails',
  components: {
    Header,
    Price,
    Footer,
    NavMenu,
    CountDown,
    BackTop
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    },
    totalDiscount: totalDiscountFilter
  }
})
export default class extends Vue {
  detailsList: any = {} // 商品详情信息

  /** 付款明细（优惠项）折叠，默认收起对齐设计稿 */
  paymentDetailExpanded: boolean = false

  createTime: string = '' // 下单时间

  updateTime: string = '' // 更新时间

  isLoading: boolean = false // loading加载

  paytime: number = 0

  // 售后列表
  mallOrderRefundList: any[] = []

  tableData: any[] = []

  giftItemCount: number = 0

  @Mutation('card/SETCARDLIST') SETCARDLIST!: Function

  created() {
    this.getOrderDetail();
    this.pageVisit();
  }

  // 确认订单列表
  private async getOrderDetail() {
    this.isLoading = true;
    const anchor = readCookie('anchor');
    const res: any = await orderDetail({
      orderNo: this.$route.query.id,
      src: orderRequestAnchorSrc(anchor)
    });
    if (res.data.code === 100) {
      const flatList: any[] = [];
      let giftCount = 0;
      res.data.data.orderDetailList.forEach((value: any) => {
        this.$set(value, 'discount_price', _.round(_.subtract(value.price, value.flashAmount), 2));
        flatList.push(value);
        if (value.giftMallImage) {
          giftCount += 1;
          flatList.push({
            _isGift: true,
            _imgSrc: value.giftMallImage.cdn_file_path_pc,
            _name: value.giftMallImage.product_name,
            _natureValue: value.giftMallImage.natureValue,
            _price: value.giftMallImage.price ? value.giftMallImage.price.price : 0,
            _num: value.giftMallImage.num
          });
        }
      });
      this.tableData = flatList;
      this.giftItemCount = giftCount;
      this.detailsList = res.data.data;
      this.createTime = dateTimeFormatter(res.data.data.createTime);
      this.updateTime = dateTimeFormatter(res.data.data.updateTime);
      // this.paytime = countDown(Number(res.data.data.surplus));
      this.isLoading = false;
    }
  }

  private addAmount(val: number, num: number) {
    return _.round(_.multiply(val, num), 2);
  }

  // 确认收货
  private async confirmReceived(item: any) {
    for (let i = 0; i < item.orderDetailList.length; i += 1) {
      if (item.orderDetailList[i].refundStatus === 1) {
        this.$message.warning('该订单售后中，不可确认收货!');
        return;
      }
    }
    this.$confirm('您是否确认收货?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        const res: any = await orderReceived({ orderNo: item.orderNo });
        if (res.data.code === 100) {
          const integral = res.data.data.integral > 0 ? 'bolck' : 'none';
          const growth = res.data.data.growthValue > 0 ? 'bolck' : 'none';
          this.$message.success({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `
            <p style="margin-bottom: 8px; color: #333; font-size: 14px;">收货成功</p>
            <span style="display: ${integral}; color: #999; font-size: 12px;">奖励积分+${res.data.data.integral}；</span>
            <span style="display: ${growth}; color: #999; font-size: 12px;">奖励成长值+${res.data.data.growthValue}</span>
          `
          });
          this.getOrderDetail();
        } else {
          this.$message.error(res.data.message);
        }
      })
      .catch(() => {});
  }

  // 再次购买
  private async buyAgain(status: number) {
    const anchor = readCookie('anchor');
    const res: any = await createOrderAgain({
      orderNo: this.$route.query.id,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : ''
    });
    if (res.data.code === 100) {
      await getDataOrder({
        orderNum: '',
        orderStatus: status,
        refundReason: '',
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: orderRequestAnchorSrc(anchor),
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: this.$route.query.from ? '3.1.1.3.1.0.1' : '3.2.1.4.1.0.1',
        companyId: 1
      });
      this.$router.push('/card');
    } else {
      this.$message.error(res.data.message);
    }
  }

  //  申请售后
  private applyscale(element: any, id: number) {
    if (element.canRefund) {
      const obj = [
        {
          id: element.id,
          buyNum: element.buyNum,
          price: element.price,
          product_name: element.productName,
          norms: element.natureList,
          orderNo: element.orderNo,
          mallImage: element.mallImage.sourceUrl,
          totalPrice: element.totalPrice

        }
      ];
      writeStorage('exchangeList', obj);
      this.$router.push(
        this.$route.query.from
          ? `/exchange?id=${element.id}&sendid=${id}&from=center&orderNo=${this.$route.query.id}`
          : `/exchange?id=${element.id}&sendid=${id}&orderNo=${this.$route.query.id}`
      );
    }
  }

  // 获取售后申请列表
  private async toogleExpand(row: any) {
    const res: any = await refundListDetail({
      orderDetailId: row.id
    });
    this.mallOrderRefundList = res.data.data.mallOrderRefundList;
    (this.$refs as any).table.toggleRowExpansion(row);
  }

  private applyDetails(id: string) {
    this.$router.push(`/exchange-details?id=${id}`);
  }

  // 取消订单
  private async cancelOrder() {
    const res: any = await orderCancel({
      orderNo: this.detailsList.orderNo
    });
    if (res.data.code === 100) {
      this.$message.success('取消成功！');
      this.$router.push('/order-list');
    }
  }

  private goPay() {
    const anchor = readCookie('anchor');
    getDataOrder({
      orderNum: '',
      orderStatus: 0,
      refundReason: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: orderRequestAnchorSrc(anchor),
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: this.$route.query.from ? '3.1.1.1.1.0.1' : '3.2.1.2.1.0.1',
      companyId: 1
    });
    this.$router.push(`/payment?id=${this.$route.query.id}`);
  }

  //  点击商品到详情
  godetails(item: any) {
    const obj = item;
    obj.num = item.buyNum;
    this.SETCARDLIST([obj]);
    this.$router.push({
      path: `/details?id=${item.productId}`,
      query: {
        productPriceId: item.productPriceId,
        shareUserId: ''
      }
    });
  }

  // 评价
  private async comment(details: object) {
    sessionStorage.setItem('commentDetails', JSON.stringify(details));
    (this as any).$router.push({ name: 'Comment' });
  }

  // 复制成功
  private onCopy() {
    this.$message.success('复制成功！');
  }

  // 复制失败
  private onError() {
    this.$message.error('该浏览器不支持自动复制,请手动复制！');
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 8,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: orderRequestAnchorSrc(anchor),
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
